<template>
  <!-- Experience Modal -->
  <div id="sick_leave_details_modal" class="modal custom-modal fade" role="dialog" ref="myModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Sick Leave Details ({{ userName }})</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">

          <table class="table">
            <thead>
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Working day</th>
                <td>{{ userDetails.working_day }}</td>
              </tr>
              <tr>
                <th scope="row">Non working day</th>
                <td>{{ userDetails.non_working_day }}</td>
              </tr>
              <tr>
                <th scope="row">No schedule</th>
                <td>{{ userDetails.no_schedule }}</td>
              </tr>
              <tr>
                <th scope="row">Sickness Details</th>
                <td>{{ userDetails.detail_sickness ? userDetails.detail_sickness : "--" }}</td>
              </tr>
              <tr>
                <th scope="row">Doctor visit</th>
                <td>{{ userDetails.is_doctor_visit ? "Yes" : "No" }}</td>
              </tr>
              <tr v-if="userDetails.is_doctor_visit">
                <th scope="row">Visit Date</th>
                <td>{{ userDetails.doctor_visit_date ? userDetails.doctor_visit_date : "--" }}</td>
              </tr>
              <tr v-if="userDetails.is_doctor_visit">
                <th scope="row">Treatment</th>
                <td>{{ userDetails.treatment ? userDetails.treatment : "--" }}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
  <!-- /Experience Modal -->


</template>
<script>
// import { ref } from "vue";
import { minToTimeString } from "@/utils/util-funcitons";

export default {
  data() {
    return {
      select2: null,
      isPositive: true,
      comment: '',
      valueInMins: 0,
      loader: false,
      bankedTimeId: '',
      userDetails: [],
      userId: '',
      date: '',
      userName: ''
    };
  },
  mounted() {

  },
  methods: {

    updateValues(item, name) {
      this.userDetails = item;
      this.userId = item.user_id;
      this.userName = name;
      console.log(this.userDetails, this.userName)
    },

    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    isNegative(number) {
      return number < 0;
    },

    timeStringToInt(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    },


  },

};
</script>
